<template>
    <div class="cars-list-item">
        <div class="cars-list-item__center">
            <CarDetailsSection :car="car" />
        </div>

        <div class="cars-list-item__right">
            <div class="cars-list-item__right-section">
                <UIInput
                    id="starting_price"
                    v-model="formStartPrice"
                    label="Стартовая цена"
                    :is-currency="true"
                    :error-message="errors.join() ?? ''"
                />

                <UISimpleButton
                    button-type="outlined"
                    @clicked="emit('removed', car)"
                >
                    Убрать
                </UISimpleButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { PropType, ref, watch } from 'vue';

    import { Car } from '@/types/car.type.ts';

    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    import CarDetailsSection from '@/components/auction/CreateAuction/CarDetailsSection/CarDetailsSection.vue';

    const { car } = defineProps({
        car: {
            type: Object as PropType<Car>,
            required: true,
        },
        errors: {
            type: Array as PropType<string[]>,
            default: [],
        },
    });

    const emit = defineEmits<{
        (e: 'removed', car: Car): void,
        (e: 'changed', car: Car): void,
    }>();

    const formStartPrice = ref<string>(car.start_price > 0 ? `${car.start_price}` : '');

    watch(formStartPrice, (val) => {
        handleChangePrice(val);
    });

    function handleChangePrice(price: string): void {
        car.start_price = price.length > 0 ? parseInt(price) : 0;
        emit('changed', car);
    }
</script>

<style lang="scss" scoped>
    @use 'CarListItem';
</style>
